export enum DeviceLastCommandStatus {
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CREATED = 'CREATED',
  PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED'
}

export interface DeviceLastCommand {
  id: string;
  command: string;
  source: string;
  requestedBy: string;
  parameters: any;
  createdAt: string | null;
  status: DeviceLastCommandStatus;
  statusMessage: string | null;
  processingAt: string | null;
  completedAt: string | null;
  failedAt: string | null;
  device?: {
    id: string;
    name: string;
  };
}

export const REFRESH_COMMAND_ELIGIBLE_OPERATORS: readonly string[] = ['Orange France', 'Vodafone WW'];

export const getDeviceCommandTimestamp = (command: DeviceLastCommand | null): string | null | undefined =>
  command?.failedAt || command?.completedAt || command?.processingAt || command?.createdAt;
